import { useLocation, Navigate } from 'react-router-dom';
import { useContextStore } from '../../store/contextStore';
import { getModuleForPath } from '../../utils/moduleRoutes';
import { ROUTES } from '../../utils/routes';

/**
 * When the current route belongs to a feature module (Automation, Governance, Integrations)
 * that is disabled via app config, redirects to home. Otherwise renders nothing.
 * Place once inside the layout so it runs for all protected routes.
 */
export function ModuleGuard() {
  const location = useLocation();
  const enabledModules = useContextStore((s) => s.enabledModules);

  const moduleKey = getModuleForPath(location.pathname);
  if (!moduleKey) return null;

  const isEnabled =
    (moduleKey === 'Automation' && enabledModules.automation) ||
    (moduleKey === 'Governance' && enabledModules.governance) ||
    (moduleKey === 'Integrations' && enabledModules.integrations);

  if (!isEnabled) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return null;
}
